// eslint-disable-next-line filenames/match-exported
import FindContactContainer from './findContact';

export default FindContactContainer;
